export default __webpack_public_path__ + "static/media/freedom_gatia_logotype.dab11b0a.png";